import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { notificationFeature } from './state/notification.feature';
import { NotificationEffects } from './state/notification.effects';

export const NOTIFICATION_STORE_PROVIDERS = {
  feature: makeEnvironmentProviders([provideState(notificationFeature)]),
  effects: provideEffects(NotificationEffects),
};
